import { Injectable } from '@angular/core';
import { KeycloakService } from 'keycloak-angular';

@Injectable({
  providedIn: 'root'
})
export class SessionService {
  private readonly SESSION_KEY = 'userSession';
  private sessionTimeout = 20 * 60 * 1000; // 20 minutes
  constructor() {
    this.initializeSession();
  }

  private initializeSession() {
    const lastActiveTime = localStorage.getItem(this.SESSION_KEY);
    if (lastActiveTime) {
      const now = new Date().getTime();
      const lastActive = parseInt(lastActiveTime, 10);
    
      if (now - lastActive > this.sessionTimeout) {
        this.clearSession();
        // Handle session expiration
      } else {
        localStorage.setItem(this.SESSION_KEY, now.toString());
      }
    } else {
      localStorage.setItem(this.SESSION_KEY, new Date().getTime().toString());
    }
  }

  public updateSession() {
    localStorage.setItem(this.SESSION_KEY, new Date().getTime().toString());
  }

  public clearSession() {
    localStorage.removeItem(this.SESSION_KEY);
  }
}
